import campaignConfig from './campaign'

export default {
  sentry: {
    dsn: 'https://abff6b4c25674fb6a0ee7feef453275b@o387488.ingest.sentry.io/5222823',
    whitelistUrls: [
      // new RegExp(`localhost`),
      new RegExp(`${campaignConfig.domain}`),
      /(.*)scan2recycle.com/,
      /(.*)promotion-manager.app/,
    ],
  },
}
